import moment from 'moment';

export default (value: any) => {
  return value ? moment.utc(value).local().format("DD/MM/YYYY HH:mm:ss") : value;
};